export default __webpack_public_path__ + "static/media/UHD_PRO_2.51f84709.png";